import { usePersonApi } from "../api/PersonApiClient";
import { PersonFrontendService } from "../services/PersonFrontendService";

export const usePersonService = (): PersonFrontendService =>
  new PersonFrontendService(usePersonApi());
